var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversitiesAdduni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_89209",
    "data-name": "Group 89209",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.388,
    height: 45.388,
    viewBox: "0 0 45.388 45.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2762",
    "data-name": "Ellipse 2762",
    transform: "translate(0)",
    fill: "none",
    stroke: "#387f75",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.694,
    cy: 22.694,
    r: 22.694,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.694,
    cy: 22.694,
    r: 21.194,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(12.765 12.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3298",
    "data-name": "Rectangle 3298",
    width: 20.567,
    height: 20.567,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(2.234 2.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54528",
    "data-name": "Path 54528",
    d: "M20.822,13.479H15.207V7.864a.864.864,0,0,0-1.728,0v5.615H7.864a.864.864,0,0,0,0,1.728h5.615v5.615a.864.864,0,0,0,1.728,0V15.207h5.615a.864.864,0,1,0,0-1.728Z",
    transform: "translate(-7 -7)",
    fill: "#387f75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversitiesAdduni);
export default __webpack_public_path__ + "static/media/universities-adduni.b7780e92b796e314c6766159cd1946bd.svg";
export { ForwardRef as ReactComponent };